module.exports = __webpack_public_path__ + "media/images/lp_chintai/sec01_ico_01-c016badf49cdd8a1f59aa9856fec16a8.png";